export default "__VITE_ASSET__LgCJVA9K__"